import PropTypes from 'prop-types';
import React, { useState, useEffect, Suspense } from 'react';
import Loader from './components/Common/Loader';
import { Routes, Route } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './routes';
import Authmiddleware from './routes/route';
import VerticalLayout from './components/VerticalLayout/';
import HorizontalLayout from './components/HorizontalLayout/';
import NonAuthLayout from './components/NonAuthLayout';
import { ModalProvider, useModal } from './context/ModalContext';
import { setupAxiosInterceptors } from './helpers/AuthType/api_helper';
import './assets/scss/theme.scss';
import './assets/css/design-tokens.css';
import SessionExpiredModal from 'context/SessionExpiredContext';
import { MasterDataProvider } from 'context/MasterDataContext';
import { USER_ROLE_KEYS } from 'constants/variable';

const AppContent = () => {
  const [layoutType, setLayoutType] = useState('vertical');
  const { isModalOpen, closeModal, showModal } = useModal();

  useEffect(() => {
    setLayoutType('vertical');
  }, []);

  useEffect(() => {
    setupAxiosInterceptors(() => {
      showModal();
    });
  }, [showModal]);

  const Layout = layoutType === 'horizontal' ? HorizontalLayout : VerticalLayout;

  return (
    <React.Fragment>
      <SessionExpiredModal isOpen={isModalOpen} onClose={closeModal} />
      <Suspense fallback={<Loader message="Loading application..." />
      }>
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route USER_ROLE_KEYS
              path={route.path}
              element={
                <NonAuthLayout>
                  {route.component}
                </NonAuthLayout>
              }
              key={idx}
              exact={true}
            />
          ))}
          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <Layout>{route.component}</Layout>
                </Authmiddleware>
              }
              key={idx}
              exact={true}
            />
          ))}
        </Routes>
      </Suspense>
    </React.Fragment>
  );
};

const App = () => {
  return (
    <ModalProvider>
      <MasterDataProvider>
        <AppContent />
      </MasterDataProvider>
    </ModalProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

export default App;